import React, { useState } from "react";
import styled from "styled-components";
import moment from 'moment';

import { useTheme } from '../../../../Context/ThemeContext';
import { useLanguage } from '../../../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import UserProfile from "../../../../Component/Normal/UserProfile";

import { ReactComponent as LeftArrowSvg } from '../../../../image/LeftArrow.svg';

export default function QueuedMemberInfoBox(props) {
  const {
    memberData,
    index,
    onViewUserPhone,
    onClickMemberProfileOrText,
    onClickAddReserveOnQueue,
    onClickDownQueueIndex
  } = props;

  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const [isHover, setIsHover] = useState(false);

  return (
    <InfoWrapper key={'Queues-' + index} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
      <ImageTooltipWrapper isHover={isHover}>
        <ImageTooltip>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={theme.subBackground} cursor='default'>
            {t('reservation.requestTime') + moment(memberData.createdDate).format(t('reservation.requestDateFormat'))}
          </Text>
        </ImageTooltip>
        <Triangle />
      </ImageTooltipWrapper>
      <ImageWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
        <UserProfile profile={memberData.profile} defaultProfile='https://picture.link-zone.org/ZoneLogo.png' />
      </ImageWrapper>
      <MemberDataWrapper>
        <ReserveNumberWrapper>
          <TextWrapper onClick={() => onClickMemberProfileOrText(memberData)}>
            <NameWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{memberData.name}</Text>
            </NameWrapper>
            <PhoneWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} cursor='pointer'>{onViewUserPhone(memberData.phone, memberData.countryCode)}</Text>
            </PhoneWrapper>
          </TextWrapper>
          <ReserveNumberBox>
            <Text fontFamily='NotoSansKR-Medium' fontSize={10} color={theme.subBackground}>{t('reservation.waiting') + (index + 1)}</Text>
          </ReserveNumberBox>
        </ReserveNumberWrapper>
        <AddReserveButtonWrapper>
          <AddReserveButton onClick={() => onClickDownQueueIndex(memberData)}>
            <StyledDownArrow />
          </AddReserveButton>
          <AddReserveButton onClick={() => onClickAddReserveOnQueue(memberData)}>
            <StyledUpArrow />
          </AddReserveButton>
        </AddReserveButtonWrapper>
      </MemberDataWrapper>
    </InfoWrapper>
  );
}

const InfoWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 96%;
  height: 42px;

  gap: 10px;
`;

const ImageTooltipWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: -20px;
  margin-left: 28px;

  opacity: ${props => props.isHover ? 1 : 0};

  z-index: ${props => props.isHover ? 1 : -1};

  transition: all 0.3s ease-in-out;
`;

const ImageTooltip = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 5px;

  border-radius: 3px;
  background-color: ${props => props.theme.primary};
`;

const Triangle = styled.div`
  margin-left: 10px;

  width: 0;
  height: 0;

  border-top: 5px solid ${props => props.theme.primary};
  border-right: 16px solid transparent;
`;

const ImageWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 3px;

  & img {
    width: 42px;
    height: 42px;
    border-radius: 3px;
    object-fit: cover;
  }

  &:hover {
    cursor: pointer;
  }
`;

const MemberDataWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: calc(100% - 32px);
  height: 42px;

  border-bottom: 1px solid ${props => props.theme.line};
`;

const ReserveNumberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  &:hover {
    cursor: pointer;
  }
`;

const NameWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PhoneWrapper = styled.div`
  width: 148px;
  height: 21px;
  line-height: 21px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AddReserveButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const AddReserveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 23px;
  height: 23px;

  &:hover {
    cursor: pointer;
  }
`;

const StyledUpArrow = styled(LeftArrowSvg)`
  flex-shrink: 0;
  width: 8px;
  height: auto;

  transform: rotate(90deg);

  & path {
    fill: ${props => props.theme.line};
  }
`;

const StyledDownArrow = styled(LeftArrowSvg)`
  flex-shrink: 0;
  width: 8px;
  height: auto;

  transform: rotate(-90deg);

  & path {
    fill: ${props => props.theme.line};
  }
`;

const ReserveNumberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;
  margin-top: 4px;

  height: 17px;

  border-radius: 17px;
  background-color: ${props => props.theme.pointYellow};

  &:hover {
    cursor: default;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  cursor: ${props => props.cursor};
`;
